const NEWTON = 101.9716213;
const PSI_FACTOR = 14.5;

function getBoreArea(pistonDiameter) {
  return Math.pow(pistonDiameter / 2, 2) * Math.PI / 100;
}

function getRodArea(pistonDiameter, rodDiameter) {
  let boreArea = getBoreArea(pistonDiameter);
  return boreArea - (Math.pow(rodDiameter / 2, 2) * Math.PI / 100);
}

function getAreaSpeed(area, lpm) {
  return 100 / (
    (
      ((area * 100 / 10) / 1000) / lpm
    ) * 60
  );
}

function getForce(pressure, area, type = 'kg') {
  if (type === 'kg') {
    return (pressure * area / 100) * NEWTON;
  } else if (type === 'kN') {
    return (pressure * area / 100);
  }

  return type;
}

function round(num) {
    return num.toFixed(2);
}

export { getBoreArea, getRodArea, getAreaSpeed, getForce, round, PSI_FACTOR };
